import {AssetStarExchangeOptionPutDataTransferObject} from "../../data-transfer-object/asset/AssetStarExchangeOptionPutDataTransferObject"

/**
 * 스타 교환 옵션 속성 설명
 */
export const AssetStarExchangeOptionPutDataTransferObjectDescription: Record<keyof AssetStarExchangeOptionPutDataTransferObject, string> = {
    starAmount: '지급 스타',
    solarAmount: '차감 솔라'
}
